import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

import {Mixture} from "../../data/mixtures";
import {Router} from "@angular/router";
import {Dialog} from "@angular/cdk/dialog";
import {OrderComponent} from "../../dialogs/order/order.component";

@Component({
    selector: 'app-product-table',
    imports: [],
    templateUrl: './product-table.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './product-table.component.scss'
})
export class ProductTableComponent {
  @Input() headline = ''
  @Input() products: Mixture[] = []
  @Input() mode: 'mixing'|'pressure' = 'mixing'
  lang: 'de'|'en' = document.location.href.match( /\/de\// ) ? 'de' : 'en'

  constructor(private router: Router,
              private dialog: Dialog) {
  }

  openPdf(product: Mixture) {
    window.open(this.getPdfUrl(product), '_blank')
  }

  getPdfUrl(product: Mixture) {
    if (this.lang === 'de') {
      return `https://finechemicals.panpage.de/DIN4/DE2/Performance_Intermediates/Specialties/ID_${product.sheet_id_de}.pdf`
    }

    return `https://finechemicals.panpage.de/DIN4/EN2/Performance_Intermediates/Speciaties/ID_${product.sheet_id_en}.pdf`
  }

  openMail(product: Mixture) {
    const to = 'drivosol@evonik.com'
    const subject = `Drivosol ${product.name}`

    const link = document.createElement('a')
    link.href = `mailto:${to}?subject=${subject}`
    link.click()
  }

  openPressure(pressure: number) {
    this.router.navigate([$localize`:@@link_pressure:/pressure`], {fragment: `bar-${pressure}`}).then()
  }

  openMixing(name: string) {
    this.router.navigate([$localize`:@@link_mixing:/mixing`], {fragment: `drivosol-${name}`}).then()
  }

  openSampleOrder(product: Mixture) {
    this.dialog.open(OrderComponent, {
      data: {product, mode: this.mode}
    })
  }
}
